"use client";

import React from "react";
import { ArrowRight, AudioLines, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Feature() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: visualRef,
    isVisible: isVisualVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="186181" id="meet-pocketpal" className="relative overflow-hidden bg-[#0D1B2A] py-24 sm:py-32 shadow-[inset_0_0_100px_rgba(60,197,243,0.05)]">
      {}
      <div className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[600px] w-[800px] rounded-full bg-[#3CC5F3]/5 opacity-40 blur-[120px]" />
      
      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-2 lg:gap-8 items-center">
          
          {}
          <div ref={textRef} className={`flex flex-col justify-center gap-8 transition-all duration-1000 ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="inline-flex items-center gap-2 rounded-full border border-[#3CC5F3]/30 bg-[#3CC5F3]/10 px-4 py-1.5 text-sm font-bold text-[#3CC5F3] w-fit uppercase tracking-wider">
              <Sparkles className="size-4" />
              <span>24/7 AI Voice Agent</span>
            </div>
            
            <div className="space-y-6">
              <h2 className="text-5xl font-black tracking-tighter text-white sm:text-6xl lg:text-8xl font-sans uppercase leading-[0.9]">
                MEET <br />
                <span className="text-[#3CC5F3]">POCKETPAL</span>
              </h2>
              
              <p className="text-xl text-white/80 max-w-xl leading-snug font-medium">
                Find office and industrial space without the friction. PocketPal handles the search, the screening, and the scheduling. Always free for tenants.
              </p>
            </div>

            <div className="pt-4">
              <Link to="/PocketPalPage">
                <Button size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive has-[>svg]:px-4 bg-[#FCB231] h-16 px-10 text-lg font-black uppercase tracking-tight shadow-[0_0_20px_rgba(252,178,49,0.4)] transition-all rounded-lg !text-[hsl(214,57%,21%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-[#FCB231]/90 hover:shadow-[0_0_40px_rgba(252,178,49,0.6)]">TALK TO POCKETPAL<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right ml-2 size-6 stroke-[3px]" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/Feature.tsx|sig:au3cgh" data-ast-start="2995" data-ast-end="3046"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></Button>
              </Link>
            </div>
          </div>

          {}
          <div ref={visualRef} className={`relative flex min-h-[500px] items-center justify-center transition-all duration-1000 delay-300 ${isVisualVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
            {}
            <div className="absolute size-96 rounded-full bg-[#3CC5F3]/10 blur-3xl animate-pulse" />
            
            {}
            <div className="absolute size-80 rounded-full border border-[#3CC5F3]/20 border-dashed animate-[spin_20s_linear_infinite]" />
            
            {}
            <div className="absolute size-64 rounded-full border border-[#3CC5F3]/40 animate-[spin_15s_linear_infinite_reverse]" />
            
            {}
            <div className="absolute size-48 rounded-full border border-[#3CC5F3]/50 animate-ping opacity-30" style={{
            animationDuration: '3s'
          }} />
            
            {}
            <div className="relative flex items-center justify-center size-40 rounded-full bg-[#0D1B2A]/50 backdrop-blur-xl border border-[#3CC5F3]/50 shadow-[0_0_60px_-15px_#3CC5F3]">
              {}
              <div className="absolute size-24 rounded-full bg-[#3CC5F3]/80 animate-pulse shadow-[0_0_40px_#3CC5F3]" style={{
              animationDuration: '2s'
            }} />
              
              {}
              <AudioLines className="relative z-10 size-14 text-[#0D1B2A] animate-pulse" style={{
              animationDuration: '1.5s'
            }} />
            </div>

            {}
            <div className="absolute top-1/4 left-1/4 size-2 rounded-full bg-[#FCB231] shadow-[0_0_15px_#FCB231] animate-bounce" style={{
            animationDelay: '0.5s'
          }} />
            <div className="absolute bottom-1/3 right-1/4 size-3 rounded-full bg-[#3CC5F3] shadow-[0_0_20px_#3CC5F3] animate-bounce" style={{
            animationDelay: '1.2s'
          }} />
          </div>

        </div>
      </div>
    </section>;
}